import React from 'react';
import {FormattedMessage} from 'react-intl';
import {string, bool, func, object} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {basicForm} from 'utils/helpers';
import config from './awardDaysFormConfig';

const AwardDaysForm = basicForm(config);

const AwardDaysModal = props => (
  <BasicModal
    header={<FormattedMessage id='userManagement.userDetail.modals.awardDays.header' values={{email: props.email}} />}
    specialType='primary-modal db-create-break-modal fadeInUp animResponse'
    dimmer='inverted'
    modalSize='small'
    actions={[
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.awardDays.cancel' />,
        action: props.handleClose,
        isDisabled: props.awarding,
        displayType: 'menu-item'
      },
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.awardDays.submit' />,
        action: props.submit,
        loading: props.awarding,
        isDisabled: props.hasErrors || false,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <AwardDaysForm
      onValueChanged={props.onValueChanged}
      onValidationError={props.onValidationError}
      errors={props.errors}
      data={props.formData} />
  </BasicModal>
);

AwardDaysModal.propTypes = {
  formData: object.isRequired,
  submit: func.isRequired,
  onValueChanged: func.isRequired,
  onValidationError: func,
  hasErrors: bool,
  handleClose: func.isRequired,
  email: string,
  modalOpen: bool.isRequired,
  awarding: bool
};

export default AwardDaysModal;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/AwardDaysModal/AwardDaysModal.jsx